export default {
  init() {

    // create two half width div within the body
      $('<div>').attr({'class':'half_left'}).appendTo('body');
      $('<div>').attr({'class':'half_right'}).appendTo('body');
      $('<div>').attr({'class':'half_left animated'}).appendTo('body');
      $('<div>').attr({'class':'half_right animated'}).appendTo('body');
  },
  finalize() {
    $(document).on('mousemove', handle_mouse_move);

    // RIP nice animation. Sorry J.


    function handle_mouse_move(event) {
      if ( $('.nav-full').hasClass('opened_section') || ($('.header-quickcart').css('transform') != 'matrix(1, 0, 0, 0, 0, 0)')) return;

      var eventDoc, doc, body;
      event = event || window.event; // IE-ism
      if (event.pageX == null && event.clientX != null) {
          eventDoc = (event.target && event.target.ownerDocument) || document;
          doc = eventDoc.documentElement;
          body = eventDoc.body;
          event.pageX = event.clientX +
            (doc && doc.scrollLeft || body && body.scrollLeft || 0) -
            (doc && doc.clientLeft || body && body.clientLeft || 0);
          event.pageY = event.clientY +
            (doc && doc.scrollTop  || body && body.scrollTop  || 0) -
            (doc && doc.clientTop  || body && body.clientTop  || 0 );
      }
  
      var half_screen = $(window).width() / 2;
      var top_menu_height = $('.nav-primary').outerHeight();
      var top_menu_position = $('.nav-primary').offset().top;
  
      if ( (event.pageY < (top_menu_position + top_menu_height)) && (event.pageY > top_menu_position)) {
        highlight_block();
      } else {
        if (event.pageX < half_screen) {
          highlight_block('left');
        } else {
          highlight_block('right');
        }
      }
    }
    
    function highlight_block(which) {
      switch(which) {
        case 'left':
          $('.half_left').addClass('highlighted');
          $('.half_right').removeClass('highlighted');
          $('li a').removeClass('italic');
          $('li a[href*="publishing"]').addClass('italic');
          break;
        case 'right':
          $('.half_right').addClass('highlighted');
          $('.half_left').removeClass('highlighted');
          $('li a').removeClass('italic');
          $('li a[href*="studio"]').addClass('italic');
          break;
        default:
          $('.half_right').removeClass('highlighted');
          $('.half_left').removeClass('highlighted');
          $('li a').removeClass('italic');
      }
    }
    
    var $carousel = $('.image_column');

    $carousel.find('img').each(function() {
      var $t = $(this);
      $t.attr({
          'data-flickity-lazyload-srcset': $t.data('srcset'),
        })
        .removeAttr('data-srcset')
        .attr({
          'data-flickity-lazyload-src': $t.data('src'),
        })
        .removeAttr('data-src')
        .removeClass('lazy');
        console.log($(this));
    });

    $carousel.flickity({
      pageDots: false,
      fullscreen: false,
      cellSelector: 'div',
      prevNextButtons: false,
      wrapAround: true,
      imagesLoaded: true,
      draggable: false,
      autoPlay: 4000,
      fade: true,
      lazyLoad: 3,
      pauseAutoPlayOnHover: false,
    });

    $carousel.flickity('pausePlayer');

    $('body').on('click', function() {
      var x = event.pageX;
      var y = event.pageY;
      if (y < $('header.banner').outerHeight()) return;
      if ($('.nav-full').hasClass('opened_section') && x > ($(window).innerWidth() - $('.opened_section').outerWidth()) ) return;

      if (x > ( $(window).width() / 2) ) {
        window.location.href = '/studio/';
      } else window.location.href = '/publishing/';
    });

    setTimeout(function(){
      $('.tagline').fadeOut();
      $carousel.addClass('active');
      $carousel.flickity('unpausePlayer');
    }, 3000);    
   

    // Functions to rearrange the home page on load, this should be done in a nicer way but will do for now
    
    },
};




// WEBPACK FOOTER //
// ./scripts/routes/home.js